import { useUpdateUserCustomStatusMutation } from '@modules/workspace/hooks/useUpdateUserCustomStatusMutation';
import { useMutation } from '@tanstack/react-query';
import { useAuthContext } from 'src/auth/useAuthContext';
import { UserRequest } from 'src/requests/user';

export const useUpdateUserStatusMutation = () => {
  const { updateUserCustomStatus } = useUpdateUserCustomStatusMutation();

  const { refresh } = useAuthContext();

  const { mutateAsync: updateUserStatus, isLoading: isUpdatingUserStatus } =
    useMutation({
      mutationFn: UserRequest.updateUserStatus,
      onSuccess: async (updatedUser) => {
        await updateUserCustomStatus({
          userId: updatedUser._id,
          customStatus: updatedUser?.customStatus,
        });
        refresh();
      },
    });

  return {
    updateUserStatus,
    isUpdatingUserStatus,
  };
};
